/**
 *
 * MiniModeBook
 *
 */

import { findIndex } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import Swal from 'sweetalert2';

import TrackerButton from '@/components/TrackerButton.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import ToolBar from '@/components/ToolBar.vue';
import Footer from '@/components/Footer.vue';
import Spinner from '@/components/Spinner.vue';
import Player from '@/components/Player.vue';
import { ClassChineseFrmMixin } from '@/mixins/ClassChineseFrm';
import { getDurationString } from '@/utils';

export default {
  name: 'MiniModeBook',

  mixins: [ClassChineseFrmMixin],

  components: {
    WayFindBar,
    ToolBar,
    Footer,
    Spinner,
    Player,
    TrackerButton,
  },

  data: () => {
    return {
      isShowPlayer: false,
      currentVideo: {},

      generating: false,
      currentFileIdx: -1,
    };
  },

  computed: {
    ...mapGetters({
      immLoading: 'immLoading',
      Book: 'MiniModeBook/Book',
      isRequest: 'MiniModeBook/isRequest',
      ReadyToPlayVideos: 'MiniModeBook/ReadyToPlayVideos',
    }),

    CourseId: function () {
      return this.$route.params.courseId;
    },

    BookId: function () {
      return this.$route.params.bookId;
    },
  },

  created() {
    this.getBook(this.BookId);
  },

  methods: {
    ...mapActions({
      getBook: 'MiniModeBook/getBook',
      addToFavoriteList: 'MiniModeBook/addToFavoriteList',
      generateFile: 'MiniModeBook/generateFile',
    }),

    openPlayer(bullet) {
      this.currentVideo = this.ReadyToPlayVideos.find(v => v.bulletId == bullet.bulletId);
      this.isShowPlayer = true;
    },

    closePlayer() {
      this.isShowPlayer = false;
    },

    goToNextVideo() {
      const index = findIndex(this.ReadyToPlayVideos, this.currentVideo);
      this.currentVideo = this.ReadyToPlayVideos[index + 1];
    },

    goBack() {
      this.$router.go(-1);
    },

    changeBulletStatus(video, status) {
      this.$store.commit('MiniModeBook/SET_BULLET_STATUS', { video, status });
    },

    async markVideo(payload) {
      await this.addToFavoriteList(payload);
      Swal.fire({
        width: '400px',
        backdrop: false,
        icon: 'success',
        title: `${this.currentVideo.collected ? '收藏成功' : '已取消收藏'}`,
        showConfirmButton: false,
        timer: 800,
      });
    },

    getDurationStringText(second) {
      return getDurationString(second);
    },

    async generatePDF(file, idx) {
      this.generating = true;
      this.currentFileIdx = idx;
      await this.generateFile({
        courseId: this.CourseId,
        bookId: file.nodeId,
        fileId: file.fileId,
      });
      this.generating = false;
      this.currentFileIdx = -1;
    },
  },
};
